var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThickCottonPants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80,12.8H40c-0.55,0-1-0.45-1-1v-8c0-0.55,0.45-1,1-1h40c0.55,0,1,0.45,1,1v8C81,12.35,80.55,12.8,80,12.8z  M41,10.8h38v-6H41V10.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,109.2H68c-0.51,0-0.93-0.38-0.99-0.88l-7-59.84l-7.02,59.84c-0.06,0.5-0.49,0.88-0.99,0.88H32 c-0.55,0-1-0.45-1-1v-76c0-0.06,0.01-0.13,0.02-0.19l4-20.4c0.09-0.47,0.5-0.81,0.98-0.81h48c0.48,0,0.89,0.34,0.98,0.81l4,20.4 C88.99,32.07,89,32.14,89,32.2v76C89,108.75,88.55,109.2,88,109.2z M68.89,107.2H87V32.3l-3.82-19.5H36.82L33,32.3v74.9h18.11 l7.91-67.44c0.06-0.5,0.49-0.88,0.99-0.88l0,0c0.51,0,0.93,0.38,0.99,0.88L68.89,107.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80,109.2H68c-0.51,0-0.93-0.38-0.99-0.88l-7-59.84l-7.02,59.84c-0.06,0.5-0.49,0.88-0.99,0.88H40 c-0.55,0-1-0.45-1-1v-76c0-0.06,0.01-0.13,0.02-0.19l4-20.4c0.09-0.47,0.5-0.81,0.98-0.81h32c0.48,0,0.89,0.34,0.98,0.81l4,20.4 C80.99,32.07,81,32.14,81,32.2v76C81,108.75,80.55,109.2,80,109.2z M68.89,107.2H79V32.3l-3.82-19.5H44.82L41,32.3v74.9h10.11 l7.91-67.44c0.06-0.5,0.49-0.88,0.99-0.88l0,0c0.51,0,0.93,0.38,0.99,0.88L68.89,107.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86,117.2H70c-0.55,0-1-0.45-1-1v-8c0-0.55,0.45-1,1-1h16c0.55,0,1,0.45,1,1v8 C87,116.75,86.55,117.2,86,117.2z M71,115.2h14v-6H71V115.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,117.2H34c-0.55,0-1-0.45-1-1v-8c0-0.55,0.45-1,1-1h16c0.55,0,1,0.45,1,1v8 C51,116.75,50.55,117.2,50,117.2z M35,115.2h14v-6H35V115.2z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickCottonPants);
export default __webpack_public_path__ + "static/media/ThickCottonPants.4c81f49eb2c551410d3b5567e8ea1d8d.svg";
export { ForwardRef as ReactComponent };